import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

  body {
    background: #87CEEB;
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
  }
  
`;
